import { render } from "./ElementaryTeacherListGradeLevelDataTabale.vue?vue&type=template&id=522f5ab8"
import script from "./ElementaryTeacherListGradeLevelDataTabale.vue?vue&type=script&lang=js"
export * from "./ElementaryTeacherListGradeLevelDataTabale.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__